// Компоненты
import {CreativeCoalition} from "../../general_components/CreativeCoalition";

export function ReviewsPage() {
    return (
        <div className="max_size">
            <CreativeCoalition>
                Всегда готова встретить<br/>
                ваши отзывы
            </CreativeCoalition>
            <form>
                <input
                    name="nickname"
                    type="text"
                    placeholder="Никнейм"
                    autoComplete="nickname"
                />
                <textarea
                    name="review"
                    placeholder="Отзыв"
                    autoComplete="review"
                />
                <button type="submit">Отправить</button>
            </form>
            <div className="line"/>
        </div>
    )
}